module.exports = __webpack_public_path__ + "static/media/yahoo-social-media-svgrepo-com.6f555c79.svg";